import { useFormik } from "formik";
import React from "react";
import * as Yup from "yup";
import { GroupInput } from "../../../../../../components/Form/GroupInput";
import { Input } from "../../../../../../components/Form/Input";
import { Select } from "../../../../../../components/Form/Select";
import { Textarea } from "../../../../../../components/Form/Textarea";
import {
  Container,
  ContainerForm,
} from "../../../../../../components/ModalModificationHeaderDatasheet/styled";
import { ButtunSubmit, Form } from "../../../../../create/styles";

interface ExceptionScheduling {
  nf: string;
  reason?: string;
  obs?: string;
}

interface ModalEditExceptionProps {
  onChange?: (data: ExceptionScheduling) => void;
  data: ExceptionScheduling;
  exceptionReasons: { value: string; name: string }[];
  isNew?: boolean;
}

export const ModalEditException: React.FC<ModalEditExceptionProps> = ({
  onChange,
  data,
  exceptionReasons,
  isNew = false,
}) => {
  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      nf: data.nf,
      reason: data.reason,
      obs: data.obs,
    },
    validationSchema: Yup.object({
      nf: Yup.string().required("Nota Fiscal é obrigatória"),
      reason: Yup.string(),
      obs: Yup.string().nullable(),
    }),
    onSubmit: async (data) => await handleSubmitUpdate(data),
  });

  async function handleSubmitUpdate(props: any) {
    if (onChange) onChange({ ...data, ...props });
  }

  return (
    <Container>
      <Form onSubmit={formik.handleSubmit}>
        <ContainerForm>
          <div className="containerForm">
            <h3>{isNew ? "Adicionar Ressalva" : "Editar Ressalva"}</h3>
            <GroupInput>
              <Input
                {...formik.getFieldProps("nf")}
                error={
                  formik.errors.nf && formik.touched.nf
                    ? formik.errors.nf
                    : undefined
                }
                label="Nota Fiscal"
              />
              <Select
                label="Motivo"
                data={exceptionReasons}
                {...formik.getFieldProps("reason")}
                error={
                  formik.errors.reason && formik.touched.reason
                    ? formik.errors.reason
                    : undefined
                }
              />
            </GroupInput>

            <Textarea
              label="Observação"
              {...formik.getFieldProps("obs")}
              error={
                formik.errors.obs && formik.touched.obs
                  ? formik.errors.obs
                  : undefined
              }
            />
          </div>

          <div className="containerFormButton">
            <ButtunSubmit
              style={{ margin: 0 }}
              type="button"
              onClick={formik.submitForm}
            >
              {isNew ? "Adicionar" : "Alterar"}
            </ButtunSubmit>
          </div>
        </ContainerForm>
      </Form>
    </Container>
  );
};
